




























import { highlight } from 'highlight.js'
import 'highlight.js/styles/arduino-light.css'
import { Vue, Component, Ref, Prop, VModel } from 'vue-property-decorator';

const CODE_AREA_REF = 'codeArea'

@Component({
  data() {
    return {
      CODE_AREA_REF
    }
  }
})
export default class HttpRequestBody extends Vue {

  @Prop({ type: String, default: 'json', required: false }) language!: 'json' | 'xml'

  @VModel() field!: string

  @Ref(CODE_AREA_REF) codeBeautify!: HTMLElement

  @Ref('highlight-container') highlightContainer!: HTMLSpanElement

  onkeydown(e: KeyboardEvent) {
    if (e.code === "Tab") {
      e.preventDefault()

      const target = e.target

      if (target instanceof HTMLTextAreaElement) {
        target.setRangeText('\t', target.selectionStart, target.selectionEnd, 'end')
      }
    }
  }

  beautifyHTML(value: string) {
    this.codeBeautify.innerHTML = highlight(value, { language: this.language }).value
  }

  onKeyUp(e: KeyboardEvent) {
    if (e.target instanceof HTMLTextAreaElement) {
      this.beautifyHTML(e.target.value)
    }
  }

  handleScroll(ev: UIEvent) {
    const pre = this.highlightContainer.firstElementChild
    const textarea = ev.target as HTMLTextAreaElement | undefined

    if (pre && textarea) {
      pre.scrollLeft = textarea.scrollLeft
      pre.scrollTop = textarea.scrollTop
    }

    return false
  }

  mounted() {
    this.beautifyHTML(this.field)
  }
}
